<template>
  <div class="tax-rate-remote">
    <v-btn
      v-if="showButton"
      color="primary"
      variant="elevated"
      @click="openDialog"
      prepend-icon="mdi-percent"
    >
      세금 요율 관리
    </v-btn>

    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title class="dialog-title">
          세금 요율 관리
          <v-spacer></v-spacer>
          <v-btn icon variant="text" @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <div class="header-actions">
            <v-btn
              color="primary"
              variant="outlined"
              @click="addTaxRate"
              prepend-icon="mdi-plus"
              class="add-btn"
            >
              연도 추가
            </v-btn>
          </div>

          <div class="tax-table-container">
            <table class="tax-table">
              <thead>
                <tr>
                  <th class="year-col">연도</th>
                  <th>국민연금</th>
                  <th>건강보험</th>
                  <th>고용보험</th>
                  <th>장기요양</th>
                  <th>산재보험</th>
                  <th>실업급여</th>
                  <th>최저시급</th>
                  <th>인건비비율</th>
                  <th class="action-col">작업</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="tax in taxRateList"
                  :key="tax.tr_idx || tax.tempId"
                  :data-tax-id="tax.tempId"
                  :class="{ 'is-deleted': tax.isDeleted }"
                >
                  <td class="year-col">
                    <v-text-field
                      v-model="tax.tr_year"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="연도"
                      class="year-input"
                      maxlength="4"
                      @input="validateYear(tax)"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_yeon"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_yeon')"
                      @input="onRateInput($event, tax, 'tr_yeon')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_gun"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_gun')"
                      @input="onRateInput($event, tax, 'tr_gun')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_go"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_go')"
                      @input="onRateInput($event, tax, 'tr_go')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_jang"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_jang')"
                      @input="onRateInput($event, tax, 'tr_jang')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_san"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_san')"
                      @input="onRateInput($event, tax, 'tr_san')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_sil"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.000"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_sil')"
                      @input="onRateInput($event, tax, 'tr_sil')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_time_pay"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0"
                      class="money-input"
                      @focus="onMoneyFocus($event, tax, 'tr_time_pay')"
                      @blur="onMoneyBlur($event, tax, 'tr_time_pay')"
                      @input="onMoneyInput($event, tax, 'tr_time_pay')"
                    />
                  </td>
                  <td>
                    <v-text-field
                      v-model="tax.tr_labor_cost_rate"
                      type="text"
                      variant="outlined"
                      density="compact"
                      hide-details
                      placeholder="0.00"
                      class="rate-input"
                      @focus="onRateFocus($event)"
                      @blur="onRateBlur($event, tax, 'tr_labor_cost_rate')"
                      @input="onRateInput($event, tax, 'tr_labor_cost_rate')"
                    />
                  </td>
                  <td class="action-col">
                    <v-btn
                      color="error"
                      variant="outlined"
                      @click="removeTaxRate(tax)"
                      icon="mdi-delete"
                      size="small"
                    />
                  </td>
                </tr>
                <tr v-if="taxRateList.length === 0" class="no-data">
                  <td colspan="10" class="text-center">
                    <v-icon color="grey">mdi-percent-outline</v-icon>
                    <span>세금 요율 데이터 없음</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="rate-info">
            <p><strong>※ 요율 입력 안내</strong></p>
            <ul>
              <li>국민연금, 건강보험, 고용보험, 장기요양, 산재보험, 실업급여: 소수점 형태로 입력 (예: 4.5% → 0.045)</li>
              <li>최저시급: 원 단위로 입력 (예: 9,860원 → 9860)</li>
              <li>인건비비율: 소수점 형태로 입력 (예: 60% → 0.6)</li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="dialog = false">취소</v-btn>
          <v-btn color="primary" variant="elevated" @click="saveTaxRates" :loading="saving">
            <v-icon class="mr-1">mdi-content-save</v-icon>
            저장
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn variant="text" @click="snackbar.show = false">닫기</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';
import axios from 'axios';

// Props
interface Props {
  showButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showButton: false
});

interface TaxRate {
  tr_idx?: number;
  tr_year: string;
  tr_yeon: number | string;
  tr_gun: number | string;
  tr_go: number | string;
  tr_jang: number | string;
  tr_san: number | string;
  tr_sil: number | string;
  tr_time_pay: number | string;
  tr_labor_cost_rate: number | string;
  isNew?: boolean;
  isDeleted?: boolean;
  tempId?: string;
  isValid?: boolean;
}

const dialog = ref(false);
const taxRateList = ref<TaxRate[]>([]);
const saving = ref(false);
const snackbar = ref({ 
  show: false, 
  message: '', 
  color: 'success',
  icon: 'mdi-check-circle'
});

const loadTaxRates = async () => {
  try {
    const response = await axios.get('/api/calc/tax-rate');
    if (response.data.success) {
      taxRateList.value = response.data.data.map((t: TaxRate) => ({
        ...t,
        tr_time_pay: formatMoney(t.tr_time_pay || 0),
        isNew: false,
        isDeleted: false,
        isValid: true
      }));
    }
  } catch (error) {
    console.error('세금 요율 조회 실패:', error);
    showSnackbar('세금 요율 조회에 실패했습니다', 'error', 'mdi-alert-circle');
  }
};

const addTaxRate = () => {
  const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const currentYear = new Date().getFullYear();
  
  const newTaxRate: TaxRate = {
    tr_year: String(currentYear),
    tr_yeon: 0.045,
    tr_gun: 0.03545,
    tr_go: 0.009,
    tr_jang: 0.1281,
    tr_san: 0.007,
    tr_sil: 0.008,
    tr_time_pay: '',
    tr_labor_cost_rate: 0.6,
    isNew: true,
    isDeleted: false,
    tempId,
    isValid: false
  };
  
  taxRateList.value.unshift(newTaxRate);
  
  // 새로 추가된 항목에 포커스
  nextTick(() => {
    const yearInput = document.querySelector(`[data-tax-id="${tempId}"] .year-input input`) as HTMLInputElement;
    if (yearInput) {
      yearInput.focus();
    }
  });
  
  showSnackbar('연도를 추가했습니다', 'info', 'mdi-plus-circle');
};

const validateYear = (tax: TaxRate) => {
  const year = tax.tr_year?.trim();
  tax.isValid = Boolean(year && year.length === 4 && /^\d{4}$/.test(year));
  
  if (year && year.length > 4) {
    tax.tr_year = year.substring(0, 4);
  }
};

// 금액 포맷팅 함수
const formatMoney = (amount: number | string): string => {
  if (!amount && amount !== 0) return '';
  const numericValue = typeof amount === 'string' ? parseFloat(amount.replace(/[^\d]/g, '')) : amount;
  if (isNaN(numericValue)) return '';
  return new Intl.NumberFormat('ko-KR').format(numericValue);
};

// 금액 입력 필드 포커스 이벤트 (컴마 제거)
const onMoneyFocus = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  (tax as any)[field] = numericValue;
};

// 금액 입력 필드 포커스 아웃 이벤트 (컴마 추가)
const onMoneyBlur = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = formatMoney(parseInt(numericValue));
    input.value = formattedValue;
    (tax as any)[field] = formattedValue;
  } else {
    input.value = '';
    (tax as any)[field] = '';
  }
};

// 금액 입력 필드 입력 이벤트 (숫자만 허용)
const onMoneyInput = (event: Event, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 12) {
    value = value.slice(0, 12);
  }
  
  input.value = value;
  (tax as any)[field] = value;
};

// 요율 입력 필드 포커스 이벤트
const onRateFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  input.select();
};

// 요율 입력 필드 포커스 아웃 이벤트
const onRateBlur = (event: FocusEvent, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  const value = parseFloat(input.value);
  
  if (!isNaN(value)) {
    (tax as any)[field] = value;
  } else {
    (tax as any)[field] = 0;
  }
};

// 요율 입력 필드 입력 이벤트
const onRateInput = (event: Event, tax: TaxRate, field: string) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  // 숫자와 소수점만 허용
  value = value.replace(/[^\d.]/g, '');
  
  // 소수점이 여러 개인 경우 첫 번째만 유지
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }
  
  input.value = value;
  (tax as any)[field] = value;
};

const removeTaxRate = (tax: TaxRate) => {
  if (tax.isNew) {
    const index = taxRateList.value.indexOf(tax);
    taxRateList.value.splice(index, 1);
    showSnackbar('세금 요율을 삭제했습니다', 'info', 'mdi-delete');
  } else {
    tax.isDeleted = true;
    showSnackbar('세금 요율을 삭제 목록에 추가했습니다', 'warning', 'mdi-delete-outline');
  }
};

// 숫자 문자열을 숫자로 변환하는 함수
const parseMoneyValue = (value: number | string): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  return parseFloat(String(value).replace(/[^\d]/g, '')) || 0;
};

const parseRateValue = (value: number | string): number => {
  if (typeof value === 'number') return value;
  if (!value) return 0;
  return parseFloat(String(value)) || 0;
};

const saveTaxRates = async () => {
  // 유효성 검사
  const invalidTax = taxRateList.value.filter(t => 
    !t.isDeleted && (!t.tr_year?.trim() || !/^\d{4}$/.test(t.tr_year))
  );
  
  if (invalidTax.length > 0) {
    showSnackbar('연도를 4자리 숫자로 입력해주세요', 'error', 'mdi-alert-circle');
    return;
  }

  saving.value = true;
  try {
    let count = 0;
    const errors: string[] = [];

    // 삭제
    const deletes = taxRateList.value.filter(t => t.isDeleted && t.tr_idx);
    for (const t of deletes) {
      try {
        await axios.delete(`/api/calc/tax-rate/${t.tr_idx}`);
        count++;
      } catch (error) {
        errors.push(`삭제 실패: ${t.tr_year}`);
      }
    }

    // 추가
    const inserts = taxRateList.value.filter(t => t.isNew && !t.isDeleted && t.tr_year.trim());
    for (const t of inserts) {
      try {
        await axios.post('/api/calc/tax-rate', {
          tr_year: t.tr_year,
          tr_yeon: parseRateValue(t.tr_yeon),
          tr_gun: parseRateValue(t.tr_gun),
          tr_go: parseRateValue(t.tr_go),
          tr_jang: parseRateValue(t.tr_jang),
          tr_san: parseRateValue(t.tr_san),
          tr_sil: parseRateValue(t.tr_sil),
          tr_time_pay: parseMoneyValue(t.tr_time_pay),
          tr_labor_cost_rate: parseRateValue(t.tr_labor_cost_rate)
        });
        count++;
      } catch (error) {
        errors.push(`추가 실패: ${t.tr_year}`);
      }
    }

    // 수정
    const updates = taxRateList.value.filter(t => !t.isNew && !t.isDeleted && t.tr_idx);
    for (const t of updates) {
      try {
        await axios.put(`/api/calc/tax-rate/${t.tr_idx}`, {
          tr_year: t.tr_year,
          tr_yeon: parseRateValue(t.tr_yeon),
          tr_gun: parseRateValue(t.tr_gun),
          tr_go: parseRateValue(t.tr_go),
          tr_jang: parseRateValue(t.tr_jang),
          tr_san: parseRateValue(t.tr_san),
          tr_sil: parseRateValue(t.tr_sil),
          tr_time_pay: parseMoneyValue(t.tr_time_pay),
          tr_labor_cost_rate: parseRateValue(t.tr_labor_cost_rate)
        });
        count++;
      } catch (error) {
        errors.push(`수정 실패: ${t.tr_year}`);
      }
    }

    if (errors.length > 0) {
      showSnackbar(`일부 저장 실패: ${errors.length}건`, 'warning', 'mdi-alert');
    } else {
      showSnackbar(`저장 완료! (${count}건 처리)`, 'success', 'mdi-check-circle');
    }
    
    await loadTaxRates();
  } catch (error) {
    console.error('저장 실패:', error);
    showSnackbar('저장 중 오류가 발생했습니다', 'error', 'mdi-alert-circle');
  } finally {
    saving.value = false;
  }
};

const showSnackbar = (message: string, color: string = 'success', icon: string = 'mdi-check-circle') => {
  snackbar.value = { show: true, message, color, icon };
};

// 다이얼로그 열릴 때 데이터 로드
const openDialog = () => {
  dialog.value = true;
  loadTaxRates();
};

// 외부에서 접근 가능하도록 노출
defineExpose({
  openDialog
});
</script>

<style lang="scss" scoped>
@import './TaxRateRemote.scss';
</style>







